function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var getSharedStyles = color => ({
  position: 'absolute',
  left: '8px',
  width: '8px',
  height: '8px',
  borderRadius: 'full',
  backgroundColor: color
});

export var loaderTheme = {
  baseStyle: _ref => {
    var {
      color
    } = _ref;
    return {
      container: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '16px',
        overflow: 'hidden'
      },
      dots: {
        position: 'relative',
        width: '56px',
        height: '8px'
      },
      first: getSharedStyles(color),
      second: getSharedStyles(color),
      third: _objectSpread(_objectSpread({}, getSharedStyles(color)), {}, {
        left: '24px'
      }),
      forth: _objectSpread(_objectSpread({}, getSharedStyles(color)), {}, {
        left: '40px'
      })
    };
  }
};
//# sourceMappingURL=Loader.theme.js.map